import { useMemo, useState } from 'react';
import { rfpOneUseCase } from '@/container/Client/Rfp/One/UseCase/RfpOneUseCase';
import { ONLINE_QUESTION_ANSWER_STATUS_INPUT, ONLINE_QUESTION_ANSWER_STATUS_NO_INPUT, } from '@/define/consts/rfp';
/**
 * データの取得, タブ管理, コンポーネントに渡す値に変更する
 */
export const useRfpClientOneQuestionPage = (args) => {
    const { auth, profile, rfp } = args;
    // タブの管理
    const [tabIndex, changeTabIndex] = useState(1);
    const { id, is_call_end: isCallEnd, name: title, online_questions: onlineQuestions, unanswered_online_question_count: unansweredQuestionCount, unread_negotiate_message_count: unreadMessageCount, unread_share_document_message_count: unreadFileCount, view_request_count: viewRequestCount, view_request_unapproved_count: unapprovedCount, } = rfp;
    // メンバーに関する情報 取得
    const { isCanUpdateMember, isMemberAdmin, members } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    // question 分類別 取得
    const { allQuestions, inputQuestions, noInputQuestions } = useMemo(() => {
        const memoNoInputQuestions = onlineQuestions.filter((question) => question.answer_status === ONLINE_QUESTION_ANSWER_STATUS_NO_INPUT.value);
        const memoInputQuestions = onlineQuestions.filter((question) => question.answer_status === ONLINE_QUESTION_ANSWER_STATUS_INPUT.value);
        return {
            allQuestions: onlineQuestions,
            inputQuestions: memoInputQuestions,
            noInputQuestions: memoNoInputQuestions,
        };
    }, [onlineQuestions]);
    // activeTab の questions 取得
    const questions = useMemo(() => {
        if (tabIndex === 2)
            return noInputQuestions;
        if (tabIndex === 3)
            return inputQuestions;
        return allQuestions;
    }, [allQuestions, noInputQuestions, inputQuestions, tabIndex]);
    return {
        allQuestions,
        changeTabIndex,
        id,
        inputQuestions,
        isCallEnd,
        isCanUpdateMember,
        isMemberAdmin,
        members,
        noInputQuestions,
        questions,
        tabIndex,
        title,
        unansweredQuestionCount,
        unapprovedCount,
        unreadFileCount,
        unreadMessageCount,
        viewRequestCount,
    };
};
